import style from './ButtonBase.module.scss';

const ButtonBase = ({ children, className = '', color, onClick, disabled, active = false, type = 'button' }) => {
  return (
    <button
      type={type}
      className={`${style.button} ${color ? style['button-' + color] : ''} ${
        active ? style['button-active'] : ''
      } ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ButtonBase;
